import { h } from './index-6e9159ae.js';
import { c as createRipple } from './ripple-d1912f02.js';
import { g as getRippleColorForButtonStyle, a as getClassNameForButtonStyle } from './button-style-ec67036b.js';

const Button = (props, children) => {
  const rippleColor = getRippleColorForButtonStyle(props.style);
  const className = getClassNameForButtonStyle(props.style);
  const attributes = {
    class: props.class ? `${className} ${props.class}` : className,
    part: props.part,
    onClick: props.onClick,
    title: props.title,
    type: props.type,
    role: props.role,
    'aria-label': props.ariaLabel,
    'aria-expanded': props.ariaExpanded,
    'aria-pressed': props.ariaPressed,
    'aria-checked': props.ariaChecked,
    'aria-current': props.ariaCurrent,
    'aria-controls': props.ariaControls,
    'aria-hidden': props.ariaHidden,
    disabled: props.disabled,
    ref(buttonEl) {
      var _a;
      if (props.form) {
        buttonEl === null || buttonEl === void 0 ? void 0 : buttonEl.setAttribute('form', props.form);
      }
      if (props.ariaHidden) {
        buttonEl === null || buttonEl === void 0 ? void 0 : buttonEl.setAttribute('aria-hidden', props.ariaHidden);
      }
      if (props.tabIndex) {
        buttonEl === null || buttonEl === void 0 ? void 0 : buttonEl.setAttribute('tabindex', props.tabIndex);
      }
      (_a = props.ref) === null || _a === void 0 ? void 0 : _a.call(props, buttonEl);
    },
  };
  return (h("button", { ...attributes, onMouseDown: (e) => createRipple(e, { color: rippleColor }) },
    props.text ? h("span", { class: "truncate" }, props.text) : null,
    children));
};

export { Button as B };

//# sourceMappingURL=button-ab6bd1ba.js.map